import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import Navigation from '../components/Navigation';
import OrganisationTextLibrariesTable from '../components/OrganisationTextLibrariesTable';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';
import DismissableAlert from '../components/DismissableAlert';

import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    FormGroup,
    InputGroup
} from 'react-bootstrap';

import { translate } from 'react-i18next';

import './OrganisationTextLibraries.css';

class OrganisationTextLibraries extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            textlibraries: [],
            page: props.page,
            pageCount: 0,
            limit: 40,
            search: props.search,
            selected: props.selected - 1,
            error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            }
        };
    }

    componentDidMount() {
        this.loadOrganisationInformation();
        this.loadOrganisationTextLibrariesFromServer();
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    saveTextLibrary(textlibrary, newName) {
        var self = this;
        axios
            .put(`${config.baseURL}/textlibraries/${textlibrary.uuid}`, {
                name: newName
            })
            .then(function(response) {
                self.loadOrganisationTextLibrariesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    deleteTextLibrary(textlibrary) {
        var self = this;
        axios
            .delete(`${config.baseURL}/textlibraries/${textlibrary.uuid}`)
            .then(function(response) {
                self.loadOrganisationTextLibrariesFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationTextLibrariesFromServer() {
        var self = this;
        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}/textlibraries`, {
                params: {
                    page: self.state.page,
                    limit: self.state.limit,
                    search: self.state.search
                }
            })
            .then(function(response) {
                self.setState({
                    textlibraries: response.data.textLibraries,
                    pageCount: response.data.pageCount
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handlePageClick = data => {
        let selected = data.selected + 1;

        const url = new URL(window.location.href);
        url.searchParams.set('page', selected);
        window.history.pushState(null, null, url);

        this.setState({ page: selected, selected: data.selected }, () => {
            this.loadOrganisationTextLibrariesFromServer();
        });
    };

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = event => {
        const { t } = this.props;

        const url = new URL(window.location.href);

        if(this.state.search) {
            url.searchParams.set('search', this.state.search);
        } else {
            url.searchParams.delete('search');
        }

        window.history.pushState(null, null, url);

        event.preventDefault();
        this.loadOrganisationTextLibrariesFromServer();
    };

    handleCreateClicked() {
        const { t } = this.props;

        this.dialog.show({
            body: t('OrganisationTextLibrariesTable.textlibrary_name'),
            prompt: Dialog.TextPrompt({
                placeholder: t('OrganisationTextLibrariesTable.name'),
                initialValue: ''
            }),
            actions: [
                Dialog.Action(
                    t('Dialog.cancel'),
                    () => console.log('Cancel!'),
                    'btn-default'
                ),
                Dialog.Action(
                    t('TextLibrarySnippet.add_textlibrary'),
                    dialog => this.didClickAdd(dialog.value),
                    'btn-danger'
                )
            ],
            bsSize: 'large',
            onHide: dialog => {
                dialog.hide();
            }
        });
    }

    didClickAdd(newName) {
        const { t } = this.props;
        const { uuid } = this.props.match.params;

        try {
            let self = this;
            axios
                .post(
                    `${config.baseURL}/organisations/${uuid}/textlibraries`,
                    {
                        name: newName,
                        global: true
                    }
                )

                .then(function(response) {
                    self.setState({
                        error: {
                            hidden: false,
                            title: `${t('CreateTextLibrary.success')}:`,
                            style: 'success',
                            message: `${t(
                                'CreateTextLibrary.created_message'
                            )}`
                        }
                    });

                    self.loadOrganisationTextLibrariesFromServer();
                })
                .catch(function(err) {
                    self.setState({
                        error: {
                            hidden: false,
                            title: `${t('CreateTextLibrary.error')}:`,
                            style: 'danger',
                            message: err.response.data.message || 'Unknown'
                        }
                    });
                });
        } catch (e) {
            this.setState({
                error: {
                    hidden: false,
                    title: `${t('CreateTextLibrary.error')}:`,
                    style: 'danger',
                    message: `${t('CreateTextLibrary.unknown_error')}`
                }
            });
        }
    }

    render() {
        const { t } = this.props;
        document.title = `MySign Digital Screen Solutions | ${t(
            'OrganisationTextLibraries.title'
        )}`;

        const user = this.state.user;
        const { uuid } = this.props.match.params;

        return (
            <div className="OrganisationTextLibraries">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('OrganisationTextLibraries.title')}{' '}
                                    <small>
                                        {this.state.organisation_name}
                                    </small>
                                    {this.state.userIsAuthorized(user, [
                                        'staff_super_admin',
                                        'staff_admin',
                                        'organisation_admin',
                                        'organisation_user'
                                    ]) ? (
                                        <Button
                                            className="btn-primary "
                                            onClick={() =>
                                                this.handleCreateClicked()
                                            }
                                        >
                                            <em className="fa fa-plus fa-fw" />{' '}
                                            {t('TextLibrarySnippet.add_textlibrary')}
                                        </Button>
                                    ) : null}
                                </h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-tachometer-alt" />{' '}
                                        <Link to={`/organisations/${uuid}`}>
                                            {t('Dashboard.title')}
                                        </Link>
                                    </li>

                                    <li className="active">
                                        <i className="fa fa-font" />{' '}
                                        {t(
                                            'SideNavigation.globaltextlibraries'
                                        )}
                                    </li>
                                </ol>

                                <DismissableAlert
                                    title={this.state.error.title}
                                    message={this.state.error.message}
                                    hidden={this.state.error.hidden}
                                    style={this.state.error.style}
                                />
                                <PaginationPanel
                                    heading={
                                        <Row>
                                            <Col xs={12} className="text-right">
                                                <form
                                                    role="search"
                                                    onSubmit={this.handleSubmit}
                                                >
                                                    <FormGroup controlId="search">
                                                        <InputGroup>
                                                            <FormControl
                                                                type="text"
                                                                value={
                                                                    this.state
                                                                        .search
                                                                }
                                                                onChange={
                                                                    this
                                                                        .handleChange
                                                                }
                                                                placeholder={t(
                                                                    'Search'
                                                                )}
                                                            />
                                                            <InputGroup.Button>
                                                                <Button
                                                                    onClick={
                                                                        this
                                                                            .handleSubmit
                                                                    }
                                                                >
                                                                    <i className="glyphicon glyphicon-search" />
                                                                </Button>
                                                            </InputGroup.Button>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </form>
                                            </Col>
                                        </Row>
                                    }
                                    pagination={
                                        <ReactPaginate
                                            previousLabel={t(
                                                'Pagination.previous'
                                            )}
                                            nextLabel={t('Pagination.next')}
                                            breakLabel={<Link to="#">...</Link>}
                                            breakClassName={'break-me'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={2}
                                            pageRangeDisplayed={5}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'pagination'}
                                            subContainerClassName={
                                                'pages pagination'
                                            }
                                            activeClassName={'active'}
                                            forcePage={this.state.selected}
                                        />
                                    }
                                >
                                    <OrganisationTextLibrariesTable
                                        userIsAuthorized={
                                            this.state.userIsAuthorized
                                        }
                                        user={this.state.user}
                                        textlibraries={
                                            this.state.textlibraries
                                        }
                                        uuid={uuid}
                                        onSave={this.saveTextLibrary.bind(
                                            this
                                        )}
                                        onDelete={this.deleteTextLibrary.bind(
                                            this
                                        )}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(OrganisationTextLibraries);
